/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($)
{
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function()
            {
                // JavaScript to be fired on all pages
            },
            finalize: function()
            {
                // JavaScript to be fired on all pages, after page specific JS is fired
            },
        },
        // Home page
        'home': {
            init: function()
            {
                // JavaScript to be fired on the home page
            },
            finalize: function()
            {
                // JavaScript to be fired on the home page, after the init JS
            },
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function()
            {
                // JavaScript to be fired on the about us page
            },
        },
    }

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args)
        {
            var fire
            var namespace = Sage

            funcname = (funcname === undefined) ? 'init' : funcname

            fire = func !== ''
            fire = fire && namespace[func]
            fire = fire && typeof namespace[func][funcname] === 'function'

            if (fire) {
                namespace[func][funcname](args)
            }
        },
        loadEvents: function()
        {
            // Fire common init JS
            UTIL.fire('common')

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm)
            {
                UTIL.fire(classnm)
                UTIL.fire(classnm, 'finalize')
            })

            // Fire common finalize JS
            UTIL.fire('common', 'finalize')
        },
    }

    // Load Events
    $(document).ready(UTIL.loadEvents)

    $('.navigation__toggle').on('click', function(e)
    {
        e.preventDefault()

        $('body').toggleClass('show-nav')
    })

    $('body').on('click', function(e)
    {
        $('.nav.chaploop').removeClass('nav-open')
    })

    $('.nav.chaploop').not('.nav-open').on('click', 'li.current-menu-item', function(e)
    {
        e.preventDefault()
        e.stopPropagation()

        $('.nav.chaploop').addClass('nav-open')
    })

    $('.clickable-block').on('click', function(e)
    {
        e.preventDefault()

        document.location.href = $(this).find('a').attr('href')
    })

    // Only listen for DOM node inserted when RTP container is present
    // We can't check for ID, since remote code will change it.
    if ($('.rtp_container').length !== 0) {
        // Since the content of the RTP container is loaded externally we need to listen for it being added
        $(document).on('DOMNodeInserted', function(e)
        {
            var $target = $('.rtp_rcmd2_item_inner')

            if ($target.length !== 0) {
                // Bind click event to RTP item block to make it fully clickable
                $target.on('click', function(e)
                {
                    e.preventDefault()

                    document.location.href = $(this).find('a').attr('href')
                })

                // Remove DOMNodeInserted event listener to stop polling
                $(document).off('DOMNodeInserted')
            }
        })
    }

    const $taxonomyFilter = $('#taxonomy_filter')

    $taxonomyFilter.on('change', function()
    {
        if (!$taxonomyFilter.val()) {
            window.location = '/resource/?' + window.location.search
        } else {
            window.location = '/resources/' + $taxonomyFilter.val() + '/?' + window.location.search
        }
    })

    //For image masks: Test if browser supports css clip-mask
    var conditional = document.querySelector('body')
    var testElem = document.createElement('div')

    if (testElem.style.clipPath !== undefined) {
        conditional.classList.add('canClip')
    } else {
        conditional.classList.add('cannotClip')
    }

})(jQuery) // Fully reference jQuery after this point.
